<template>
  <common-addon>
    <template v-slot:upsell>
      <subtitle :sub-title="$t('billing.success.confirmation.workspace_assign_desc')" />
      <zm-button size="lg" type="primary" @click="navigateToWorkspaceManagement">
        {{ $t('billing.success.confirmation.workspace_cta') }}
      </zm-button>
    </template>

    <template v-slot:unassign>
      <subtitle :sub-title="assignText" />
      <zm-button size="lg" type="primary" @click="navigateToWorkspaceManagement">
        {{ $t('billing.success.confirmation.workspace_cta') }}
      </zm-button>
      <view-account type="plain" />
    </template>
  </common-addon>

</template>
<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import { navigateToTargetPage } from '@/utils/modal-utils';

export default {
  extends: CommonAddon,
  components: {
    CommonAddon,
    Subtitle,
  },
  computed: {
    assignText() {
      return this.$t('billing.success.downgrade_unassign_workspaces', [this.unassignLicenses, this.billingDate]);
    },
  },
  methods: {
    navigateToWorkspaceManagement() {
      let workspaceManagementLink = '/workspaces/management';
      // If in modal context, prepend origin to relative URLs
      if (this.$context?.is?.modal) {
        workspaceManagementLink = `${window.location.origin}${workspaceManagementLink}`;
      }
      navigateToTargetPage(workspaceManagementLink);
    },
  },
};
</script>
